import * as React from 'react';
import { useState } from 'react';
import SampleForm from "../../components/Samples/SampleForm/SampleForm";
import Submenu from '../../components/Submenu/Submenu';
import AppMenus from '../../config/appMenus';
import AppRoutes from '../../config/appRoutes';
var Sample = function () {
    var appMenus = new AppMenus();
    var _a = useState(false), isEdit = _a[0], setIsEdit = _a[1];
    var submenu = null;
    if (isEdit) {
        submenu = React.createElement(Submenu, { menuItems: appMenus.subMenuItems[AppRoutes.editSample.key] });
    }
    return (React.createElement("div", { className: "container-fluid" },
        React.createElement("div", { className: "animated fadeIn" },
            React.createElement("h1", { className: "display-3" }, "\u041D\u043E\u0432 \u0441\u0430\u043C\u043F\u044A\u043B"),
            React.createElement("hr", null),
            React.createElement("div", { className: "row" },
                isEdit ? submenu : null,
                React.createElement("div", { className: "col-md-5 " + (isEdit ? '' : 'offset-md-4') },
                    React.createElement(SampleForm
                    // @ts-ignore
                    , { 
                        // @ts-ignore
                        isEdit: setIsEdit }))))));
};
export default Sample;



//////////////////
// WEBPACK FOOTER
// ./src/views/Samples/Sample.tsx
// module id = 446
// module chunks = 0